export * from './Table';
import Table from './Table';
export default Table;
